module.exports = __webpack_public_path__ + "media/icons/check-circle-bec9b4fd.svg";